import { Box } from '@mui/material';

function Logo() {
  return <Box component="img" src="/assets/images/halo-call-summ.svg" alt="logo" width={185} />;
}

export default Logo;
